import React from "react";
import { Modal } from "react-bootstrap";

import styles from "./modal.module.scss";

const LabeledValue = ({ label, value, className = "mb-3" }) => (
	<div className={`d-flex ${className}`}>
		<div className={styles.label}>{label}:</div>
		<div className={styles.value}>{value}</div>
	</div>
);

const AgentOfficeSetupMoreDataModal = ({ show, onHide, fullName, data }) => {
	return (
		<Modal
			show={show}
			onHide={onHide}
			centered
			className={styles.centeredLabelsModal}
		>
			<Modal.Header closeButton className="pb-0">
				<Modal.Title as="h6" className="text-center mb-3">
					Primary contact: {fullName}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="d-flex flex-column pt-0">
				<LabeledValue
					label="First Name"
					value={data.firstName}
					className="mt-1 mb-3"
				/>
				<LabeledValue label="Last Name" value={data.lastName} />
				<LabeledValue label="Email" value={data.email} />
				<LabeledValue label="Phone" value={data.phoneNumber} />
				<LabeledValue label="Address" value={data.address} />
				<LabeledValue label="City" value={data.city} />
				<LabeledValue label="State" value={data.state} />
				<LabeledValue label="Zip" value={data.zip} />
			</Modal.Body>
		</Modal>
	);
};

export default AgentOfficeSetupMoreDataModal;
